<nav class="navbar navbar-expand-lg navbar-light bg-light fixed-top" *ngIf="!isMobile">
    <div class="container-fluid">
        <div class="collapse navbar-collapse" id="navbarSupportedContent" style="margin-top: 13px; width: 100%;">
            <div style="width: 30%; display: flex; align-items: center;"></div>           
            <div style="width: 70%; display: flex;align-items: center; justify-content: right;">
                <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item">
                        <button style="line-height: 17px !important;" class="btn btn-outline-success dropdown-toggle"
                            data-toggle="dropdown">{{selectedLang}}</button>
                        <div class="dropdown-menu"
                            style="min-width: 56px !important; max-width: 94px; margin-top: 0px;">
                            <a style="cursor: pointer;" class="dropdown-item" *ngFor="let lang of langArr"
                                (click)="changeLang(lang.lang_code)">{{lang.lang_name}}</a>
                        </div>
                    </li>

                    <ng-container *ngIf="profile.loginId != 'PGAdmin'">
                    <li class="nav-item active" *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))">
                        <a class="nav-link">
                            <a data-toggle="tooltip"  routerLink='/layout/dashboard' title="Home" data-placement="top" style="cursor: pointer;"><i class="fa fa-home fa-lg"
                                    aria-hidden="true"
                                    style="color: #1a9950 !important;margin-left: 15px;font-size: 18px;position: relative;cursor:pointer;"></i></a>
                        </a>
                    </li>
                </ng-container>

                <ng-container *ngIf="profile.loginId == 'PGAdmin'">
                    <li class="nav-item" *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))">
                        <div class="btn-group">
                            <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-hidden="true">
                                <a data-toggle="tooltip" title="User Management" data-placement="bottom">
                                    <i class="fa fa-users dropdown-toggle"
                                        style="color: #1a9950 !important;cursor: pointer;font-size: 18px;position: relative;margin-left: 15px; "></i>
                                </a>
                            </span>

                            <div aria-labelledby="settings1" id="popups1" class="dropdown-menu">
                                <ng-container *ngFor="let ls of USM001">
                                    <ng-container *ngIf="(ls.parent_code == 'USM001' && ls.deny_flag == 'N')">
                                <a (click)="getMenuCode(ls)" routerLink={{ls.url_action_method}} class="dropdown-item"><i class="fa fa-user" aria-hidden="true"></i> &nbsp;{{ls.menu_desc}}</a>
                                        </ng-container>
                                        </ng-container>
                            </div>
                        </div>
                    </li>
                        <li class="nav-item" *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))">
                        <div class="btn-group">
                            <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-hidden="true">
                                <a data-toggle="tooltip" title="Settings" data-placement="bottom">
                                    <i class="fa fa-cog dropdown-toggle"
                                        style="color: #1a9950 !important;cursor: pointer;font-size: 18px;position: relative;margin-left: 15px;"></i>
                                </a>
                            </span>

                            <div aria-labelledby="settings" id="popup1" class="dropdown-menu">
                                <ng-container *ngFor="let ls of MAS001">
                                    <ng-container *ngIf="(ls.parent_code == 'MAS001' && ls.deny_flag == 'N')">
                                    <a (click)='getMenuCode(ls)' routerLink={{ls.url_action_method}} class="dropdown-item"><i
                                        class="fa fa-calendar" aria-hidden="true" style="cursor: pointer;"></i>
                                    &nbsp;{{ls.menu_desc}}</a>
                                </ng-container>
                                </ng-container>
                            </div>
                        </div>
                    </li>
                    </ng-container>

                        <li class="nav-item" *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))">
                        <div class="btn-group">
                            <span data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" aria-hidden="true">
                                <a data-toggle="tooltip" title="Profile" data-placement="top">
                                    <i class="fa fa-user dropdown-toggle"
                                        style="color: #1a9950 !important;cursor: pointer;font-size: 18px;position: relative;margin-left: 15px;"></i>
                                </a>
                            </span>
                            <div aria-labelledby="settings" id="popup2" class="dropdown-menu" style="padding:0px">
                                <div
                                    style="background: #f3f8fe;border-bottom: 1px solid #EDEDED;margin-top: -7px; display: flex; flex-direction: column; align-items: center; padding: 13px;">
                                    <img src="assets/images/user-thumbnail.png"
                                        style="border-radius: 50%;height:75px;width:75px;"><br><br>
                                    <h4 style="font-size:14px;">{{statusMsg.userName}}: {{profile.userName}}</h4>
                                    <h5 style="font-size:13px;">{{statusMsg.userId}}: {{profile.loginId}}</h5>
                                    <h5 style="font-size:13px;">{{statusMsg.email}}: {{profile.email}}</h5>
                                    <h5 style="font-size:13px;">{{statusMsg.role}}: {{ profileRoleName | uppercase}}</h5>
                                    <!-- <h4 style="font-size:14px;"><a style="color:#5592d1;">My Account</a> | <a style="color:red">Sign Out</a></h4> -->
                                    <h5> <ng-container *ngFor="let ls of menuList">
                                        <ng-container *ngIf="(profile.loginId != 'PGAdmin' && ls.parent_code == 'PRO001' && ls.deny_flag == 'N')">
                                        <ng-container *ngIf="(profile.loginId != 'PGAdmin' && ls.menu_code == 'MASCHP007' && ls.deny_flag == 'N')">
                                        <a routerLink={{ls.url_action_method}} class="dropdown-item"><i
                                            class="fa fa-calendar" aria-hidden="true" style="cursor: pointer;"></i>
                                        &nbsp;{{ls.menu_desc}}</a>
                                    </ng-container>
                                    </ng-container>
                                </ng-container></h5>
                                </div>
                            </div>
                        </div>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link">
                            <a data-toggle="tooltip" (click)="logout()" title="Sign Out" data-placement="top">
                                <i class="fa fa-power-off" aria-hidden="true"
                                    style="color: #1a9950 !important;cursor: pointer;font-size: 18px;position: relative;margin-left: 15px;"></i></a>
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</nav>


<div *ngIf="isMobile" class="mobileView" style="width: 100%;">
    <div class="header-mobile__bar">
        <div class="container-fluid">
            <div class="header-mobile__bar-inner" style="display: flex; justify-content: space-between; align-items: center;">
                            <nav class="navbar navbar-expand-lg navbar-light bg-light" style="padding:0px !important; margin:0px !important;">
                                <!-- <a class="navbar-brand" href="#">Navbar</a> -->
                                <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"  aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                                <span class="navbar-toggler-icon"></span>
                              </button>
                            
                                <div class="collapse navbar-collapse" id="navbarSupportedContent" style="z-index: 999999999999999999;background-color: black; color: white;">
                                    <nav id="sidebar"  *ngIf="((getFromPage != 'forgot' && pwdFlag == 'N') || (getFromPage == 'login' && pwdFlag != 'Y'))" style="    overflow-y: scroll;
                                    height: 471px;">
                                        <ul class="list-unstyled components" id="demo"  style="margin-top: 2%;">
                                            <ng-container *ngFor="let m of menuData">
                                                <li>
                                                    <ng-container *ngIf="(m.parent_code == 'MAIN' && m.deny_flag == 'N')">
                                                        <a [href]="'#'+m.menu_code" data-toggle="collapse" aria-expanded="false" class="dropdown-toggle"
                                                            aria-controls="adminSubmenu">
                                                            <i class="fas fa-user fs-11" aria-hidden="true"></i>&nbsp;
                                                            {{m.menu_desc}}
                                                        </a>
                                                        <ul class="collapse list-unstyled" [id]="m.menu_code">
                                                        <ng-container *ngFor="let c of menuData">
                                                           
                                                <li *ngIf="(c.parent_code == m.menu_code && c.deny_flag == 'N')">
                                                    <a (click)='getMenuCode(c)' ><i class="fa fa-arrows-alt" aria-hidden="true"></i>&nbsp;{{c.menu_desc}}</a>
                                                </li>
                                            </ng-container>
                                            </ul>
                                            </ng-container>
                                    
                                            </li>
                                            </ng-container>
                                        </ul>
                                    </nav>
                                    
                                    <!-- <app-main-menu></app-main-menu> -->
                                    <!-- <ul class="navbar-nav mr-auto">
                                        <li class="nav-item active">
                                            <a style="color: white;" class="nav-link" href="#">Home <span class="sr-only">(current)</span></a>
                                        </li>
                                        <li class="nav-item">
                                            <a style="color: white;" class="nav-link" href="#">Link</a>
                                        </li>
                                    </ul> -->
                                </div>
                            </nav>
                            <a>
                                <ul class="nav navbar-nav ml-auto">
                                    <li class="nav-item">
                                        <button style="line-height: 17px !important;" class="btn btn-outline-success dropdown-toggle"
                                            data-toggle="dropdown">{{selectedLang}}</button>
                                        <div class="dropdown-menu"
                                            style="min-width: 56px !important; max-width: 94px; margin-top: 0px;">
                                            <a style="cursor: pointer;" class="dropdown-item" *ngFor="let lang of langArr"
                                                (click)="changeLang(lang.lang_code)">{{lang.lang_name}}</a>
                                        </div>
                                    </li>
                                    </ul>
                            </a>                             
                          
            </div>
        </div>
    </div>
</div>